import script from "./tutorOnboardingPaymentPlansPage.vue?vue&type=script&setup=true&lang=js"
export * from "./tutorOnboardingPaymentPlansPage.vue?vue&type=script&setup=true&lang=js"

import "./tutorOnboardingPaymentPlansPage.vue?vue&type=style&index=0&id=4d2c3b1c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d2c3b1c"]])

export default __exports__